import { FC } from 'react';
import { HotColumn } from '@handsontable/react';
import { IList } from 'core/API/listApi';
import { MObjectifPicturesHeader, translateHeaders } from './helpers/HeadersList';
import Grid from '../Grid';
import { listValidator, numberValidator } from '../Validators';
import { AutoCompleteRenderer, NumberRenderer } from './helpers/customRenderers';
import { requireTitle } from './helpers/utils';

export const MObjectifImage: FC<{
    list: IList;
    toolId: number;
    retailers: string[];
}> = ({ list, toolId, retailers }) => {
    const translatedHeaders = translateHeaders(MObjectifPicturesHeader);

    return (
        <Grid toolId={toolId} headers={MObjectifPicturesHeader} list={list}>
            <HotColumn
                title={requireTitle(translatedHeaders[0])}
                validator={listValidator(retailers)}
                source={retailers}
                type="autocomplete"
            >
                <AutoCompleteRenderer list={retailers} hot-renderer />
            </HotColumn>

            <HotColumn
                title={requireTitle(translatedHeaders[1])}
                allowEmpty={false}
                type="text"
                validator={numberValidator()}
            />
        </Grid>
    );
};
